<!--  ******************************************************  -->
<!--  CUSTOMER PRODUCTITEM CHANGE WORKFLOW STATUS DIALOG           -->
<!--    - Allows the user to change the customerProductItem owner  -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
    {{'PRODUCTITEM.CHANGE_WORKFLOW_STATUS' | translate}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content class="mat-typography dialogBody">
    <form class="example-form" #changeWorkflowStatusForm="ngForm">

      <!--  ************************************  -->
      <!--         CUSTOMER-PRODUCTITEM OWNER            -->
      <!--  ************************************  -->

      <mat-form-field class="fullWidthField">
        <mat-label>{{'PRODUCTITEM.WORKFLOW_STATUS' | translate}}</mat-label>

        <mat-select class="mat-typography" name="workflowRegistryStatus" [(ngModel)]="selectedRegistryStatus" >
          <mat-option [value]="registryStatusEnum.DA_INSTALLARE"><span class="mat-typography">{{'PRODUCTITEM.REGISTRY_STATUS.' + registryStatusEnum.DA_INSTALLARE | translate}}</span></mat-option>
          <mat-option [value]="registryStatusEnum.IN_COLLAUDO"><span class="mat-typography">{{'PRODUCTITEM.REGISTRY_STATUS.' + registryStatusEnum.IN_COLLAUDO | translate}}</span></mat-option>
          <mat-option [value]="registryStatusEnum.OPERATIVO"><span class="mat-typography">{{'PRODUCTITEM.REGISTRY_STATUS.' + registryStatusEnum.OPERATIVO | translate}}</span></mat-option>

        </mat-select>

      </mat-form-field>

    </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="changeWorkflowStatusForm.invalid" (click)="changeWorkflowStatus()">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
